import './js/preloader';
import './js/footer-modal';
import './js/fetchMovieApi';
import './js/markup_mainGallery';
import './js/modalMovieWindow';
// import './js/pagination';
import './js/showing-trailer';
import './js/dark-light';
